<template>
    <div class="bottomListBox">
        <ul class="bottomList">
            <li
            v-for="(item,index) in list"
            :key="index"
            :class="{active: bottomActiveIndex == index}"
            @click="setBottomActiveIndex(index)"
            >
                <img :src="bottomActiveIndex == index?item.url2:item.url1">
                {{ item.title }}
            </li>
        </ul>
        <transition name="rightList">
            <rightList :initState="initState" v-if="bottomActiveIndex == 3"></rightList>
        </transition>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const publicData = createNamespacedHelpers("publicData");
const mapData = createNamespacedHelpers("mapData");
import rightList from "./rightList";
export default {
    data() { 
        return {
            list: [
                {
                    url1: require("@/assets/svg/map/bottomList0.svg"),
                    url2: require("@/assets/svg/map/bottomList0_active.svg"),
                    title: "景区",
                },
                {
                    url1: require("@/assets/svg/map/bottomList1.svg"),
                    url2: require("@/assets/svg/map/bottomList1_active.svg"),
                    title: "乡村",
                },
                {
                    url1: require("@/assets/svg/map/bottomList2.svg"),
                    url2: require("@/assets/svg/map/bottomList2_active.svg"),
                    title: "路线",
                },
                {
                    url1: require("@/assets/svg/map/bottomList3.svg"),
                    url2: require("@/assets/svg/map/bottomList3_active.svg"),
                    title: "周边",
                }
            ]
        }
    },
    mounted(){
        if(this.getIntoTheState != 0){
            if(this.firstLevelIndex == 2){
                let index = 0;
                if(this.secondLevelIndex == 1){
                    index = this.secondLevelIndex;
                }else if(this.secondLevelIndex == 4){
                    index = 2;
                }
                this.setBottomActiveIndex(index);
            }else{
                this.setBottomActiveIndex(3);
            }
        }
    },
    methods: {
        ...mapData.mapMutations(["setBottomActiveIndex"])
    },
    computed: {
        ...mapData.mapState(["bottomActiveIndex"]),
        ...publicData.mapState(["getIntoTheState","secondLevelIndex","firstLevelIndex"]),
    },
    components: {
        rightList
    },
    props: {
        initState: {
            type: Boolean
        }
    },
    watch: {
        initState(nv){
            if(this.getIntoTheState != 0 && nv){
                if(this.firstLevelIndex == 2){
                    this.setBottomActiveIndex(this.secondLevelIndex);
                }else{
                    this.setBottomActiveIndex(3);
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.bottomList{
    width: 6.9rem;
	height: 1.24rem;
	background: #fff;
	border-radius: .1rem;
	position: absolute;
	left: 50%;
	bottom: .64rem;
	transform: translateX(-50%);
    box-shadow:0rem .08rem .08rem 0rem rgba(50,50,50,0.2);
    display: flex;
    align-items: center;
    li{
        flex: 1;
        height: 100%;
        font-size: .2rem;
        flex-direction: column;
        color: #999;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            margin-bottom: .1rem;
        }
        &:nth-of-type(1){
            img{
                width: .62rem;
                height: .49rem;
            }
        }
        &:nth-of-type(2){
            img{
                width: .56rem;
                height: .52rem;
            }
        }
        &:nth-of-type(3){
            img{
                width: .54rem;
                height: .52rem;
            }
        }
        &:nth-of-type(4){
            img{
                width: .48rem;
                height: .48rem;
            }
        }
        &.active{
            color: #58BFA7;
        }
    }
}
.rightList-enter,.rightList-leave-to {
	opacity: 0;
    bottom: 0;
}
// 控制元素显示过程中实现的具体动画效果
.rightList-enter-active,.rightList-leave-active {
	transition: all .3s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.rightList-enter-to,.rightList-leave {
	opacity: 1;
    bottom: 2.31rem;
}
</style>